import {Button, Col, Modal, Row} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../CoSoKBCB";
import {Formik, Form} from "formik";
import {addPhieuKeHoach, getListHD, getListTrangTB, searchdsDot, updatePhieuKeHoach} from "../services/services";
import {CODE, MAX_PAGE_SIZE, TYPE_WH} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import TableThongTinDot from "./TableThongTinDot"
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import FormThemVatTu from "./FormThemVatTu";
import DialogThongTinDot from "./DialogThongTinDot";
import DialogQuaTrinhChuyenGiao from "./DialogQuaTrinhChuyenGiao";
import {TYPE_KE_HOACH} from "../../../../quan-ly-ke-hoach/Components/danh-sach-ke-hoach/constants/constansKeHoach";
import {getPhieuKeHoach} from "../../../../quan-ly-ke-hoach/Components/danh-sach-ke-hoach/services/services";
import {TYPE_KB_CB} from "../constants/constansKeHoach";
import LabelRequired from "../../../../component/LabelRequired";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import TextField from "../../../../component/TextField";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  type: TypeKeHoach;
}

const DialogPhieuChuyenGiaoKyThuat = (props: Props) => {
  const {show, onHide, warehouseId, setInitialValues, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(false);
  const [isViewDot, setIsViewDot] = useState<boolean>(false);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>();
  const [dsDot, setDsDot] = useState([]);
  const [selectedHopDong, setSelectedHopDong] = useState<any>(null);

  const handleAddItem = async (values: any) => {
    const dataItem = values.keHoach || {};
    if (!dataItem?.content || !dataItem?.receivingHospital) return;

    const addItem = {
      content: dataItem?.content,
      receivingHospital: dataItem?.receivingHospital,
      receivingHospitalCode: dataItem?.receivingHospitalCode,
      receivingHospitalId: dataItem?.receivingHospitalId,
      receivingHospitalName: dataItem?.receivingHospitalName,
    }

    let newLstItem = [...dsKeHoach];
    if (indexRowEdit === null) {
      newLstItem = [...newLstItem, {...addItem}];
    } else {
      newLstItem[indexRowEdit] = {...addItem};
    }
    setIndexRowEdit(null);
    const updateValueForm = {
      ...dataItem,
      content: "",
      receivingHospital: "",
      receivingHospitalCode: "",
      receivingHospitalId: "",
      receivingHospitalName: ""
    }
    setInitialValuesFormThemVT(updateValueForm);
    setDsKeHoach(newLstItem);
  };

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      ...values[type?.formThongTinChung],
      type: TYPE_WH.EXPORT,
      doCreation: values?.keHoach?.id ? formatDateDTO(values?.keHoach?.doCreation) : formatDateDTO(new Date()),
      listOfInstructions: [...(dsKeHoach || [])].map(item => {
        return (
          {
            ...item,
            id: item?.id || null,
          }
        )
      }),
      contractInformation: selectedHopDong?.code,
      contractInformationName: selectedHopDong?.name,
      contractSignedAmount: selectedHopDong?.contractSignedAmount,
      trackerCode: type.trackerCode,
      termModelType: type?.formThongTinChung,
    };
    console.log(values)
    console.log(dataSubmit)
    try {
      setIsLoading(true);
      const id = values[type?.formThongTinChung]?.id;
      const {data} = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        // setIsView(true);
        // setInitialValues && setInitialValues(data?.data);
        // setDetailPhieuKeHoach({
        //   ...data?.data,
        //   statusId: detailPhieuKeHoach.statusId,
        // });
        toast.success(((id) ? "Cập nhật" : "Thêm") + " bổ sung thông tin kỹ thuật thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  // const getSelectedRowsData = async (id: string) => {
  //   try {
  //     setIsLoading(true);
  //     const {data} = await getPhieuKeHoach(id);
  //     setDsKeHoach(data?.data || []);
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   if (initialValues?.id) {
  //     getSelectedRowsData(initialValues?.id || detailPhieuKeHoach?.id);
  //   }
  // }, [initialValues?.id]);

  useEffect(() => {
    initialValues?.id && updatePageData()
  }, [initialValues?.id])
  const updatePageData = async () => {
    try {
      setSelectedHopDong({
        code: initialValues?.[type?.formThongTinChung]?.contractInformation || initialValues?.contractInformation || selectedHopDong?.code,
        name: initialValues?.[type?.formThongTinChung]?.contractInformationName || initialValues?.contractInformationName || selectedHopDong?.name,
        contractSignedAmount: initialValues?.[type?.formThongTinChung]?.contractSignedAmount || initialValues?.contractSignedAmount || selectedHopDong?.contractSignedAmount,
      })
      const {data} = await searchdsDot(initialValues?.[type?.formThongTinChung]?.id ?? initialValues?.id);
      setDsDot([])
      if (CODE.SUCCESS === data.code) {
        setDsDot(data?.data || []);

      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  useEffect(() => {
    updateForm();
  }, []);


  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({...generateInitValues(data), ...initialValues ?? {}});
  };

  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };

  const handleEdit = (rowData: any, index: number) => {
    setItemSelected({...rowData, index});
    setOpenDialogThemMoi(true);
    setIsViewDot(false);
  }
  const handleView = (rowData: any, index: number) => {
    setItemSelected({...rowData, index})
    setOpenDialogThemMoi(true);
    setIsViewDot(true);
  }
  const handleCloseDialog = () => {
    setOpenDialogThemMoi(false);
    setIsViewDot(false);
    setTimeout(() => {
      updatePageData()
    }, 500);
  };
  const [dsHopDong, setDsHopDong] = useState<any>([]);

  const getListDataTrangTB = async () => {
    try {
      const data = await getListHD({pageSize: MAX_PAGE_SIZE})
      setDsHopDong((data?.data?.data?.content ?? []))
    } catch (e) {

    }
  }

  useEffect(() => {
    getListDataTrangTB()
  }, [])
  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{[type?.formThongTinChung]: initialValues}}
        validationSchema={generateValidationSchema(listJsonGenerate, type?.formThongTinChung || "")}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`Bổ sung thông tin kỹ thuật`}/>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <GenerateFormComponent
                    isView={true}
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    propsRenderButton={handler}
                    lstSelectedRenderButton={dsKeHoach}
                    setFieldValue={setFieldValue}
                    modelID={type?.formThongTinChung}
                    customComponent={DynamicComponent}
                    warehouseId={warehouseId}
                  />

                  <div className="spaces fw-bold">
                    <hr/>
                  </div>
                  <div className="spaces 2 title">
                    <span className="title">
                      Thông tin kỹ thuật chuyển giao
                    </span>
                  </div>
                  <Row>
                    <Col lg={1} className="spaces">
                      <div className="spaces pt-10 min-w-135">
                        <div className="spaces mt-1">
                          <LabelRequired className="min-w-100px" label="Thông tin hợp đồng"/>
                        </div>
                      </div>
                    </Col>
                    <Col lg={8} className="spaces">
                      <div className="d-flex spaces pl-36">
                        <AutocompleteObjectV2
                          options={dsHopDong}
                          disabled
                          value={selectedHopDong}
                          isSearchDefauilt={true}
                          name="WmsCode"
                          onChange={(options: any) => setSelectedHopDong(options)}
                          className="autocomplete-custom-renderform mt-8 radius spaces width-100 h-29"
                          isClearable={true}
                        />
                      </div>
                    </Col>
                    <Col lg={1} className="spaces">
                      <div className="spaces pt-10 min-w-135">
                        <div className="spaces mt-1">
                          <LabelRequired className="min-w-100px" label="Giá trị hợp đồng"/>
                        </div>
                      </div>
                    </Col>
                    <Col lg={2} className="spaces">
                      <TextField
                        value={selectedHopDong?.contractSignedAmount}
                        name="contractSignedAmount"
                        disabled={true}
                        type={'number'}
                        className="spaces pl-36 mt-3 w-full"
                      />
                    </Col>
                  </Row>
                </div>

                <TableThongTinDot
                  isView={isView}
                  setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                  handleEdit={handleEdit}
                  handleView={handleView}
                  dsDot={dsDot}
                />
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {(values.keHoach?.id || detailPhieuKeHoach?.id) && !isView && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                    }}
                    // handleClick={(data: any) => {
                    //   data.code === "allowed-edit" && setIsView(false);
                    // }}
                    tracker={type.trackerCode}
                    objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                    onHide={onHide}
                  />
                )}
                {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
                <Button onClick={() => onHide()} className="btn btn-fill min-w-120px spaces mx-3">
                  <IconButtonSave/> Đóng
                </Button>
              </div>
            </Form>
        )}
      </Formik>
      {openDialogThemMoi && <DialogThongTinDot
          type={TYPE_KB_CB.NOI_DUNG_CHUYEN_GIAO}
          show={openDialogThemMoi}
          onHide={handleCloseDialog}
          initialValues={{dotChuyenGiao: itemSelected}}
          setInitialValues={setItemSelected}
          isViewDot={isViewDot}
      />}
      {/*{openDialogThemMoi && <DialogQuaTrinhChuyenGiao*/}
      {/*    type={type}*/}
      {/*    show={openDialogThemMoi}*/}
      {/*    onHide={handleCloseDialog}*/}
      {/*    initialValues={{keHoach: {...itemSelected}}}*/}
      {/*    setInitialValues={setItemSelected}*/}
      {/*/>}*/}
    </Modal>
  );
};

export default DialogPhieuChuyenGiaoKyThuat;
